import { keys } from '@direct-frontend/stdlib';
import { TRACKED_EVENTS, TrackedEvent } from '../constants';

function isTrackedEventType(type: string): type is TrackedEvent {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- автоматический игнор в рамках DIRECT-265451. Исправьте при следующем редактировании при помощи type-assert, чтобы избежать возможных ложно-положительных проверок typecheck!
    // @ts-expect-error -- Type Guard
    return TRACKED_EVENTS.includes(type);
}

const eventAliases = {
    click: new Set(['mousedown', 'mouseup', 'pointerdown', 'pointerup']),
    blur: new Set(['change']),
} satisfies Partial<Record<TrackedEvent, Set<string>>>;

/**
 * Нормализует имена событий к тем, за которыми следим
 *
 * @param eventType любой тип события
 * @returns тип отслеживаемого события или null, если событие не отслеживается
 */
export function mapEventTypeToTrackedEventType(eventType: string): TrackedEvent | null {
    if (isTrackedEventType(eventType)) {
        return eventType;
    }

    for (const trackedEventType of keys(eventAliases)) {
        if (eventAliases[trackedEventType].has(eventType)) {
            return trackedEventType;
        }
    }

    return null;
}
